'use strict';

require('theme/enterprise/main.scss');

require('babel-polyfill');

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactDom = require('react-dom');

var _reactDom2 = _interopRequireDefault(_reactDom);

var _reactRedux = require('react-redux');

var _reactRouter = require('react-router');

var _reactRouterRedux = require('react-router-redux');

var _routes = require('./routes');

var _routes2 = _interopRequireDefault(_routes);

var _create = require('./redux/create');

var _create2 = _interopRequireDefault(_create);

var _root = require('./redux/modules/root');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * THIS IS THE ENTRY POINT FOR THE CLIENT, JUST LIKE server.js IS THE ENTRY POINT FOR THE SERVER.
 */

var dest = document.getElementById('content');
var store = (0, _create2.default)(_reactRouter.browserHistory, window.__data);
var history = (0, _reactRouterRedux.syncHistoryWithStore)(_reactRouter.browserHistory, store);

var component = _react2.default.createElement(
  _reactRouter.Router,
  { history: history },
  (0, _routes2.default)(store)
);

store.runSaga(_root.rootSaga);

_reactDom2.default.render(_react2.default.createElement(
  _reactRedux.Provider,
  { store: store, key: 'provider' },
  component
), dest);

if (process.env.NODE_ENV !== 'production') {
  window.React = _react2.default; // enable debugger

  /* eslint-disable max-len, no-console */
  if (!dest || !dest.firstChild || !dest.firstChild.attributes || !dest.firstChild.attributes['data-react-checksum']) {
    console.error('Server-side React render was discarded. Make sure that your initial render does not contain any client-side code.');
  }
  /* eslint-enable max-len, no-console */
}

if (__DEVTOOLS__ && !window.devToolsExtension) {
  var DevTools = require('./containers/DevTools/DevTools');

  _reactDom2.default.render(_react2.default.createElement(
    _reactRedux.Provider,
    { store: store, key: 'provider' },
    _react2.default.createElement(
      'div',
      null,
      component,
      _react2.default.createElement(DevTools, null)
    )
  ), dest);
}


//////////////////
// WEBPACK FOOTER
// ./src/client.jsx
// module id = 1446
// module chunks = 0